export const HALF_DIVIDER     = 2;
export const HALF_MULTIPLIER  = 0.5;
export const MINUTES_PER_HOUR = 60;
export const PERCENT          = 100;
export const TWICE            = 2;
